const css = `.qOufMG__mono{font-family:var(--typography-font-monospace)}.qOufMG__serif{font-family:var(--typography-font-headline)}.qOufMG__sans{font-family:var(--typography-font-sans)}.qOufMG__small-caps{font-family:var(--typography-font-smallcaps)}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};

export default {"sans":"qOufMG__sans","mono":"qOufMG__mono","small-caps":"qOufMG__small-caps","serif":"qOufMG__serif"};
